import { useState, type ReactNode } from 'react';
import { InterfacePortalContext } from '@/foundation/ui/InterfacePortalContext';
import '../theme/tokens.css';

export function SessionPlayerBoundary({ children }: { children: ReactNode }) {
  const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(null);

  return (
    <InterfacePortalContext.Provider value={portalContainer}>
      <div
        ref={setPortalContainer}
        data-interface="session-player"
        className="min-h-dvh"
        style={{ background: 'var(--color-bg)', color: 'var(--color-text)' }}
      >
        {children}
      </div>
    </InterfacePortalContext.Provider>
  );
}
